const theme = {
  colors: {
    base: '#1cb2bf', // Teal
    secondary: '#e9e9e9', // Medium Gray
    tertiary: '#f3f3f3', // Light Gray
    highlight: '#21d1e0', // Light Blue
  },
  sizes: {
    maxWidth: '1200px',
    maxWidthCentered: '650px',
  },
  responsive: {
    small: '35em',
    medium: '50em',
    large: '70em',
  },
}

export default theme



// WEBPACK FOOTER //
// ./src/styles/theme.js